import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProfileService } from 'src/app/core/services/profile.service';
import { DashboardService } from 'src/app/views/main/dashboard/dashboard.service';

@Component({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: 'app-trends-active-rewards',
  templateUrl: './trends-active-rewards.component.html',
  styleUrl: './trends-active-rewards.component.scss'
})
export class TrendsActiveRewardsComponent implements OnInit, OnDestroy {
  trendsPoints = 0;
  isLoaded = false;
  private destroy$ = new Subject<void>();

  constructor(
    private dashboardService: DashboardService,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    // Prefer the shared state populated by the dashboard's balance-header.
    // If we land here directly (e.g. reload on /tiers), it's still at the
    // default 0 — fetch the summary ourselves so we don't wrongly show
    // "Unlock your Tier benefits" to users who already have points.
    this.dashboardService.trendsPoints$
      .pipe(takeUntil(this.destroy$))
      .subscribe((points) => {
        if (points > 0) {
          this.trendsPoints = points;
          this.isLoaded = true;
          return;
        }

        if (this.isLoaded) return;

        this.profileService
          .getPointsSummary()
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (summary) => {
              const fetched = summary?.availableAmount ?? 0;
              this.trendsPoints = fetched;
              this.isLoaded = true;
              this.dashboardService.setTrendsPoints(fetched);
            },
            error: () => {
              this.isLoaded = true;
            }
          });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
